import styled from 'styled-components'
import { CLIENT_STYLINGS, CLOUDFRONT_BASE_URL } from '../../../utils/constants'
const CheckedBox = `${CLOUDFRONT_BASE_URL}/assets/icons/CheckedCheckbox.svg`
const UncheckedBox = `${CLOUDFRONT_BASE_URL}/assets/icons/UncheckedBox.svg`

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5px;
`

export const CheckboxLabel = styled.label`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-weight: normal;
  font-size: 13px;
  line-height: 20px;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MAIN_COLOR};

  display: flex;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  flex-direction: row-reverse;
  align-content: flex-start;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
`

export const CheckboxCheckmark = styled.div`
  height: 18px;
  width: 18px;
  background-image: url(${UncheckedBox});
  background-size: contain;
`

export const CheckboxInput = styled.input`
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;

  &:checked ~ ${CheckboxCheckmark} {
    background-image: url(${CheckedBox});
  }
`

export const CheckboxError = styled.div`
  position: absolute;
  font-size: 11px;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MAIN_COLOR};
  top: 37px;
`
